import { css } from "@emotion/react";

export const rootStyle = css`
  align-items: center;
  border-color: rgba(0, 0, 0, 0.16);
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  column-gap: 8px;
  display: flex;
  height: 40px;
  justify-content: space-between;
  overflow: hidden;
  width: 132px;
`;

export const disabledRootStyle = css`
  background-color: #edf2f7;
`;

export const errorRootStyle = css`
  border-color: #e53e3e;
  box-shadow: inset 0 0 0 1px #e53e3e;
`;

export const buttonStyle = css`
  background-color: transparent;
  border: none;
  padding: 8px;
  &:not(&:disabled) {
    color: rgba(0, 0, 0, 0.92);
    cursor: pointer;
  }
  &:disabled {
    color: rgba(0, 0, 0, 0.24);
    cursor: not-allowed;
  }
`;

export const inputStyle = css`
  font-size: 16px;
  text-align: center;
  width: 36px;
  &:not(&:disabled) {
    color: rgba(0, 0, 0, 0.92);
  }
  &:disabled {
    color: rgba(0, 0, 0, 0.24);
  }
`;
